var map = {
	"./certificate1.png": 1204,
	"./certificate10.png": 5470,
	"./certificate11.png": 8487,
	"./certificate12.png": 1823,
	"./certificate13.png": 7269,
	"./certificate14.png": 2602,
	"./certificate15.png": 7811,
	"./certificate16.png": 3320,
	"./certificate17.png": 1585,
	"./certificate18.png": 1782,
	"./certificate19.png": 799,
	"./certificate2.png": 111,
	"./certificate20.png": 7471,
	"./certificate21.png": 534,
	"./certificate3.png": 1094,
	"./certificate4.png": 4169,
	"./certificate5.png": 3616,
	"./certificate6.png": 7115,
	"./certificate7.png": 5986,
	"./certificate8.png": 2933,
	"./certificate9.png": 3516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6016;